const getScrollingPosition = require('./getScrollingPosition')
const viewPush = require('./viewPush')

viewPush.getScrollingPosition = getScrollingPosition

module.exports = viewPush




// WEBPACK FOOTER //
// ./~/@dp/util-m-view-push/src/index.js